module.exports = {
  BookingNo: 'หมายเลขมอบหมาย',
  JobNo: 'หมายเลขบริการ',
  ContainerLoadType: 'ประเภทการรวมสินค้า',
  Electric: 'มีแบตเตอรี่หรือไม่',
  ElectricCol: 'มีแบตเตอรี่',
  Magnetic: 'มีแม่เหล็กหรือไม่',
  MagneticCol: 'มีแม่เหล็ก',
  Powdery: 'เป็นผงหรือไม่',
  PowderyCol: 'ผง',
  Liquid: 'เป็นของเหลวหรือไม่',
  LiquidCol: 'ของเหลว',
  DomesticWarehouse: 'คลังสินค้ารับของ',
  PreAmazonWhTime: 'เวลาที่คาดว่าจะเข้าคลัง Amazon',
  ServiceChannel: 'ช่องทางบริการ',
  WarehouseCode: 'รหัสคลังสินค้าต่างประเทศ',
  RemoteWarehouse: 'เป็นคลังสินค้าห่างไกลหรือไม่',
  ShippingType: 'วิธีการขนส่ง',
  DestinationDistribution: 'วิธีการจัดส่งปลายทาง',
  overseaWarehouse: 'คลังสินค้าต่างประเทศ',
  IncoTerm: 'ข้อกำหนดทางการค้า',
  PoNumber: 'PO (หมายเลขเดิม)',
  ShipmentId: 'รหัสการจัดส่ง',
  ReferenceId: 'รหัสอ้างอิง',
  ChargingMethod: 'วิธีการคิดเงิน',
  LclMethod: 'วิธีการรวมตู้',
  ValueAddedServices: 'บริการเพิ่มมูลค่า',
  EoriNo: 'EORI/หมายเลขบริษัท',
  TaxnoType: 'ประเภทหมายเลขภาษี',
  VatNo: 'VAT/หมายเลขภาษี',
  TaxRegisterCountry: 'ประเทศที่จด VAT',
  TaxRegisterAddress: 'ที่อยู่จด VAT',
  TaxCompany: 'บริษัท VAT (ชื่อภาษาอังกฤษ)',
  PreWarehousingTime: 'เวลาที่คาดว่าจะเข้าคลัง',
  QuantityContract: 'จำนวนชิ้นทั้งหมด (มอบหมาย)',
  WeightContract: 'น้ำหนักรวม (มอบหมาย)',
  CubageContract: 'ปริมาตรรวม (มอบหมาย)',
  VolumetricWeight: 'ปริมาตรสินค้า (มอบหมาย)',
  ChargedWeight: 'น้ำหนักคิดเงิน (มอบหมาย)',
  QuantityActual: 'จำนวนชิ้นทั้งหมด (จริง)',
  WeightActual: 'น้ำหนักรวม (จริง)',
  CubageActual: 'ปริมาตรรวม (จริง)',
  QuantityCharge: 'จำนวนชิ้นทั้งหมด (คิดเงิน)',
  WeightCharge: 'น้ำหนักรวม (คิดเงิน)',
  CubageCharge: 'ปริมาตรรวม (คิดเงิน)',
  BubbleCountingRatio: 'ค่าสัมประสิทธิ์การคิดโฟม',
  BubbleSplittingRatio: 'อัตราส่วนแบ่งโฟม',
  PickupService: 'รับของที่บ้าน',
  PickupTime: 'เวลาในการรับของ',
  PickupDoor: 'จุดรับของ',
  DoorMan: 'ผู้ติดต่อ',
  DoorManTel: 'เบอร์ติดต่อ',
  DoorAddress: 'ที่อยู่จุดรับส่ง',
  CustomerRequire: 'ความต้องการของลูกค้า',
  SubmitState: 'สถานะการส่ง',
  SubmitBy: 'ผู้ส่ง',
  importSingleOrder: 'นำเข้าออร์เดอร์เดี่ยว',
  batchImportOrder: 'นำเข้าออร์เดอร์เป็นชุด',
  downloadSingleImportTemplate: 'ดาวน์โหลดเทมเพลตนำเข้าเดี่ยว',
  downloadBatchImportTemplate: 'ดาวน์โหลดเทมเพลตนำเข้าเป็นชุด',
  SubmitDate: 'เวลาที่ส่ง',
  VerifyState: 'สถานะการตรวจสอบเบื้องต้น',
  VerifyBy: 'ผู้ตรวจสอบเบื้องต้น',
  VerifyDate: 'เวลาตรวจสอบเบื้องต้น',
  UseNewNo: 'สร้างเลขที่งานใหม่',
  BookingAudit: 'การตรวจสอบออร์เดอร์',
  ShippingTypeCannotBeEmpty: 'วิธีการขนส่งไม่สามารถเว้นว่างได้',
  ChargingMethodCannotBeEmpty: 'วิธีการคิดค่าบริการไม่สามารถเว้นว่างได้',
  DomesticWarehouseCannotBeEmpty: 'คลังสินค้าไม่สามารถเว้นว่างได้',
  WarehouseCodeCannotBeEmpty: 'รหัสคลัง Amazon ไม่สามารถเว้นว่างได้',
  ContainerLoadTypeCannotBeEmpty: 'ประเภทการรวมสินค้าไม่สามารถเว้นว่างได้',
  OperateTypeCannotBeEmpty: 'โหมดการดำเนินงานไม่สามารถเว้นว่างได้',
  BookingTermCannotBeEmpty: 'ลักษณะการจองพื้นที่ไม่สามารถเว้นว่างได้',
  VerifyRefuseReason: 'เหตุผลการปฏิเสธการตรวจสอบ',
  ReverifyRefuseReason: 'เหตุผลการปฏิเสธการตรวจทาน',
  CustomerId: 'หน่วยงานผู้ว่าจ้าง',
  LoadingPortCode: 'ท่าเรือต้นทาง',
  Packing: 'ประเภทบรรจุภัณฑ์',
  SingleImport: 'นำเข้าออร์เดอร์ FBA เดี่ยว',
  Op: 'ดำเนินการ',
  Sales: 'ฝ่ายขาย',
  Csr: 'ฝ่ายบริการลูกค้า',
  Dc: 'เอกสาร',
  CreatedBy: 'ผู้สร้าง',
  DateCreated: 'วันที่สร้าง',
  ExpressCompany: 'บริษัทขนส่งด่วน',
  ExpressNo: 'เลขที่พัสดุ',
  AmazonWarehouseCode: 'รหัสคลังสินค้า Amazon',
  OperationStatusOfForeignWarehouse: 'สถานะการดำเนินงานคลังสินค้าต่างประเทศ',
  Cargo_PolStation: 'สถานีต้นทาง (รถไฟ)',
  quotationStatus: 'สถานะการเสนอราคา',
  quotationObject: 'ผู้รับการเสนอราคา',
  hasJob: 'ต้องการนำเข้าออร์เดอร์หรือไม่',
  cannotDeleteAddedService: 'ไม่อนุญาตให้ลบบริการเสริมที่ถูกใช้งานโดยธุรกิจแล้ว!',
  changeChannel: 'ช่องทางบริการปัจจุบันไม่ได้บำรุงรักษาราคาสำหรับระดับลูกค้าปัจจุบัน ระบบไม่สามารถประมาณการค่าใช้จ่ายอัตโนมัติได้ ต้องการดำเนินการต่อหรือไม่?',
  cargoTypeNotExist: 'ช่องทางบริการปัจจุบันไม่รองรับสินค้าประเภท {0} โปรดอัปเดตประเภทสินค้า!',
  warehouseCodeNotExist: 'ช่องทางบริการปัจจุบันไม่มีจุดหมายปลายทาง {0} โปรดอัปเดตจุดหมายปลายทาง!',
  changeWarehouseCode: 'จุดหมายปลายทางมีการเปลี่ยนแปลง ต้องการรีเฟรชค่าใช้จ่ายจากเขตของช่องทางบริการเดิมหรือไม่?',
  changeCustomer: 'หน่วยงานผู้ว่าจ้างมีการเปลี่ยนแปลง ต้องการรีเฟรชค่าใช้จ่ายจากระดับลูกค้าของช่องทางบริการเดิมหรือไม่?',
  changeChargeWeight: 'น้ำหนักคิดค่าบริการมีการเปลี่ยนแปลง ต้องการรีเฟรชค่าใช้จ่ายเดิมที่คำนวณตามน้ำหนักหรือไม่? ค่าใช้จ่ายที่ออกใบแจ้งหนี้ ใบเสร็จรับเงิน คำร้องขอชำระเงิน และการตัดจ่ายแล้วจะไม่ได้รับการอัปเดต',
  refreshCharge: 'ช่องทางบริการมีการเปลี่ยนแปลง ต้องการรีเฟรชค่าใช้จ่ายเดิมที่สร้างตามช่องทางบริการหรือไม่?',
  channelInfoCannotChange: 'ช่องทางบริการนี้ไม่สามารถแก้ไข {0} ได้',
  changeVerifyShippingType: '{0}ช่องทางบริการนี้รองรับเฉพาะการขนส่งแบบ {1}',
  changeVerifyMultipleShippingType: 'ไม่สามารถแก้ไขวิธีการขนส่งสำหรับออเดอร์ที่มีช่องทางบริการที่กำลังอยู่ระหว่างการบำรุงรักษาในข้อมูลที่เลือก',
  otherOverseaWarehouse: 'คลังสินค้าต่างประเทศของบุคคลที่สาม'
}
